import type { Program, ProgramEventType } from 'models';
import { useMemo } from 'react';
import { useCreateGeneralProgramEventPermissions } from './useCreateGeneralProgramEventPermissions';

export const useCreateProgramEventPermissions = ({ program }: { program?: Program }) => {
  const createGeneralProgramEventPermissions = useCreateGeneralProgramEventPermissions();

  return useMemo(() => {
    if (program) {
      return {
        createEventAllowedTypes: ['conference', 'webinar'] satisfies ProgramEventType[],
        isCreateButtonAvailable: false,
        isTelehealthButtonAvailable: false,
      };
    }

    return createGeneralProgramEventPermissions();
  }, [program, createGeneralProgramEventPermissions]);
};
